<aside class="sidebar" [class.sidebar--collapsed]="layout.collapsed()">
  <button
    type="button"
    class="sidebar__edge-toggle"
    (click)="toggleCollapsed()"
    [attr.aria-label]="layout.collapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
    [attr.aria-expanded]="!layout.collapsed()"
  >
    <svg
      class="sidebar__edge-toggle-icon"
      width="22"
      height="22"
      viewBox="0 0 18 18"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M11 5L7 9l4 4"
        stroke="currentColor"
        stroke-width="2.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>

  <div class="sidebar__head">
    <div class="sidebar__brand">
      <span class="sidebar__logo">
        <span class="sidebar__logo-mark">aeda</span><span class="sidebar__logo-colon">:</span>
      </span>
      <span class="sidebar__logo-subtitle">admin</span>
    </div>
  </div>

  <span class="sidebar__badge">MVP — v1.0</span>

  <nav class="sidebar__nav" aria-label="Primary navigation">
    @for (section of sections(); track section.label) {
      <div class="sidebar__section">
        <div class="sidebar__section-label">{{ section.label }}</div>
        @for (item of section.items; track item.route) {
          <a
            class="sidebar__link"
            routerLinkActive="sidebar__link--active"
            [routerLink]="item.route"
            [attr.title]="layout.collapsed() ? item.label : null"
          >
            <span class="sidebar__link-icon" aria-hidden="true">{{ item.icon }}</span>
            <span class="sidebar__link-label">{{ item.label }}</span>
          </a>
        }
      </div>
    }
  </nav>

  <div class="sidebar__deferred">
    <div class="sidebar__divider"></div>
    <div class="sidebar__section-label sidebar__section-label--muted">
      DEFERRED — POST-LAUNCH
    </div>
    @for (item of deferredItems; track item) {
      <div class="sidebar__deferred-item">{{ item }}</div>
    }
  </div>

  <div class="sidebar__user">
    <div class="sidebar__divider"></div>
    @if (currentUser(); as user) {
      <div class="sidebar__user-row">
        <span class="sidebar__user-icon" aria-hidden="true">{{ user.initial }}</span>
        <span class="sidebar__user-name">{{ user.name }}</span>
      </div>
      <div class="sidebar__user-email">{{ user.email }}</div>
    }
    <button
      type="button"
      class="sidebar__logout"
      (click)="onLogout()"
      [attr.title]="layout.collapsed() ? 'Sign out' : null"
    >
      <span class="sidebar__logout-icon" aria-hidden="true">⎋</span>
      <span class="sidebar__logout-label">Sign out</span>
    </button>
  </div>
</aside>
